export const PAGES = {
    HOME: '/',
    CASE_STUDY: '/case-study',
    PAGE_NOT_FOUND: '/404',
    PRIVICY_POLICY: '/privacy-policy'
}